module.exports = __webpack_public_path__ + "static/media/PY.c671fb08.svg";